module.exports = __webpack_public_path__ + "img/ubiqu.4c747f20.svg";